<template>
    <!-- Логотип выбирается по теме; runtime-имя Zentrolink выводится рядом с его логотипом. -->
    <span class="brand-logo" :class="{ 'runtime-brand-logo': logo.kind === 'wordmark' }">
        <span v-if="logo.kind === 'wordmark'" class="brand-logo-word"><img class="company-logo" src="/branding/zentrolink/logo.svg" alt="Zentrolink"><span v-if="logo.text !== 'Zentrolink'">{{ logo.text }}</span></span>
        <img v-else-if="$store.state.logo.img != 'logoDefault.svg'" :style="$store.state.logo.style" :src="$store.state.logo.img">
        <img v-else :style="$store.state.logo.style" :src="require(`@/assets/${$store.state.logo.img}`)">
    </span>
</template>

<script>
// Ветвление wordmark/картинка вынесено в чистый модуль (тестируется на node:test).
import { resolveBrandLogo } from '@/utils/authBranding';

export default {
    computed: {
        individual() { return this.$store.state.individual; },
        // Zentrolink wordmark; Graphite and other white-label themes use the stand logo (store.logo) or logoDefault.
        logo() { return resolveBrandLogo(this.individual); },
    },
};
</script>

<style lang="scss" scoped>
.brand-logo { display: inline-flex; align-items: center; }
.company-logo { width: 174px; height: 32px; object-fit: cover; object-position: left; display: block; }
.runtime-brand-logo { min-width: 0; max-width: 100%; }
.brand-logo-word {
    min-width: 0;
    max-width: 100%;
    display: inline-flex;
    align-items: center;
    gap: 9px;
    font-family: 'HelveticaNeue bold', 'Roboto bold', sans-serif;
    font-size: 26px;
    font-weight: 700;
    line-height: 1;
    letter-spacing: -0.02em;
    color: currentColor;
    white-space: normal;
    user-select: none;
}
.brand-logo-word > span:last-child { min-width: 0; overflow-wrap: anywhere; }
</style>
